import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import RequestSentModal from '../Upselling/RequestSentModal'
import Icon from '../Icons'

const UpsellingBlocker = ({ wrapperClassName, type, text }) => {
  const { t } = useTranslation(['building-analytics'])

  return (
    <div className={wrapperClassName}>
      <Icon
        icon="padlock"
        styles={{
          width: '60px',
          height: '60px',
        }}
        fill="black"
        viewBox={'0 0 60 60'}
        svgProps={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
      />
      <h3>{text}</h3>
      <RequestSentModal
        buttonClassName="button-black"
        buttonText={t('building-analytics:upsellingBlocker.unlock')}
        type={type}
      />
    </div>
  )
}

UpsellingBlocker.propTypes = {
  wrapperClassName: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.string,
}
export default UpsellingBlocker
